import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import { runInAction } from 'mobx';
import { observer, useLocalStore } from 'mobx-react';
import * as React from 'react';
import { transl } from '../main/transl';

const ENABLE_DIALOG = false; //TODO

const useStyles = makeStyles({
	tooltip: {
		backgroundColor: '#EEE',
		color: '#F00',
		maxWidth: 220,
		fontSize: 14,
		border: '1px solid #F00',
	},
	arrow: {
		color: '#F00',
	},
});

interface IHintProps {
	tooltip?: string
	disabled?: string
	children: React.ReactElement
}

const HintDialog = observer((props: {content: string}) => {
	const classes = useStyles();
	return <Dialog open={true}>
		<DialogTitle>{transl('hint')}</DialogTitle>
		<DialogContent>{props.content}</DialogContent>
		<DialogActions><Button color="primary">{transl('ok')}</Button></DialogActions>
	</Dialog>;
});

export const Hint = observer((props: IHintProps) => {
	const classes = useStyles();
	const {disabled, tooltip, children} = props;
	const state = useLocalStore(() => ({
		isOpen: false,
		toggle() {
			runInAction(function() {
				state.isOpen = !state.isOpen && ENABLE_DIALOG;
			});
		},
	}));

	if (disabled) {
		return <div onClick={state.toggle}>
			<Tooltip arrow classes={classes} enterDelay={100} title={disabled}>{children}</Tooltip>
			{state.isOpen ? <HintDialog content={disabled}/> : null}
		</div>;
	} else if (tooltip) {
		return <Tooltip arrow title={transl(tooltip)}>{children}</Tooltip>;
	} else {
		return <>{children}</>;
	}
});
